import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import AIAssistant from '../views/AIAssistant.vue'
import ReviewCenter from '../views/ReviewCenter.vue'
import GuideRefine from '../views/GuideRefine.vue'
import DeclareAudit from '../views/DeclareAudit.vue'
import DeclareDuplicateCheck from '../views/DeclareDuplicateCheck.vue'
import ConsistencyAnalysis from '../views/ConsistencyAnalysis.vue'
import ResearchIntegrity from '../views/ResearchIntegrity.vue'
import DeclareFormatCheck from '../views/DeclareFormatCheck.vue'
import DeclareBudgetCheck from '../views/DeclareBudgetCheck.vue'
import DeclareSensitiveCheck from '../views/DeclareSensitiveCheck.vue'
import DeclareLimitCheck from '../views/DeclareLimitCheck.vue'
import ProjectReview from '../views/ProjectReview.vue'
import ExpertSelection from '../views/ExpertSelection.vue'
import ProcessCheck from '../views/ProcessCheck.vue'
import FinalAudit from '../views/FinalAudit.vue'
import ProjectList from '../views/ProjectList.vue'
import ProcessManagement from '../views/ProcessManagement.vue'
import ProjectDetail from '../views/ProjectDetail.vue'
import KnowledgeBaseSearch from '../views/KnowledgeBaseSearch.vue'

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/ai-assistant',
    name: 'AIAssistant',
    component: AIAssistant
  },
  {
    path: '/review-center',
    name: 'ReviewCenter',
    component: ReviewCenter
  },
  {
    path: '/guide-refine',
    name: 'GuideRefine',
    component: GuideRefine
  },
  {
    path: '/declare-audit',
    name: 'DeclareAudit',
    component: DeclareAudit
  },
  {
    path: '/declare-duplicate-check',
    name: 'DeclareDuplicateCheck',
    component: DeclareDuplicateCheck
  },
  {
    path: '/consistency-analysis',
    name: 'ConsistencyAnalysis',
    component: ConsistencyAnalysis
  },
  {
    path: '/research-integrity',
    name: 'ResearchIntegrity',
    component: ResearchIntegrity
  },
  {
    path: '/declare-format-check',
    name: 'DeclareFormatCheck',
    component: DeclareFormatCheck
  },
  {
    path: '/declare-budget-check',
    name: 'DeclareBudgetCheck',
    component: DeclareBudgetCheck
  },
  {
    path: '/declare-sensitive-check',
    name: 'DeclareSensitiveCheck',
    component: DeclareSensitiveCheck
  },
  {
    path: '/declare-limit-check',
    name: 'DeclareLimitCheck',
    component: DeclareLimitCheck
  },
  {
    path: '/project-review',
    name: 'ProjectReview',
    component: ProjectReview
  },
  {
    path: '/expert-selection',
    name: 'ExpertSelection',
    component: ExpertSelection
  },
  {
    path: '/process-check',
    name: 'ProcessCheck',
    component: ProcessCheck
  },
  {
    path: '/final-audit',
    name: 'FinalAudit',
    component: FinalAudit
  },
  {
    path: '/project-list',
    name: 'ProjectList',
    component: ProjectList
  },
  {
    path: '/process-management',
    name: 'ProcessManagement',
    component: ProcessManagement
  },
  {
    path: '/project-detail/:id',
    name: 'ProjectDetail',
    component: ProjectDetail
  },
  {
    path: '/knowledge-base',
    name: 'KnowledgeBaseSearch',
    component: KnowledgeBaseSearch
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
